import { useState, useRef, useEffect } from "react";

import { CameraAlertRegion } from "lib/types";
import { REGION_INDEX_COLOR } from "lib/constants";
const TEN_THOUSAND = 10000;
type CanvasProps = {
  canvasWidth: number;
  canvasHeight: number;
  canvasOffsetTop: number;
  canvasOffsetLeft: number;
};
function RegionRuleDraw(props: {
  regionDetection: CameraAlertRegion;
  ruleIndex: number;
  updateRegionDetection: (points: { x: number; y: number }[]) => void;
  canvasProps: CanvasProps;
}) {
  const { regionDetection, ruleIndex, updateRegionDetection, canvasProps } =
    props;

  const { canvasWidth, canvasHeight, canvasOffsetTop, canvasOffsetLeft } =
    canvasProps;

  const refRuleCanvas = useRef<HTMLCanvasElement>(null);

  const [canDraw, setCanDraw] = useState(false);
  const [isDrawing, setIsDrawing] = useState(false);

  const [regionMoving, setRegionMoving] = useState(false);
  const [startRegionMovePos, setStartRegionMovePos] = useState<{
    x: number;
    y: number;
  }>();

  const [pointMoving, setPointMoving] = useState(false);
  const [pointMovingIndex, setPointMovingIndex] = useState(-1);

  const [points, setPoints] = useState<{ x: number; y: number }[]>([]);
  const [cursePoint, setCursePoint] = useState<{ x: number; y: number }>();

  function transX2Canvas(x: number) {
    return Math.floor((x * canvasWidth) / TEN_THOUSAND);
  }

  function transY2Canvas(y: number) {
    return Math.floor((y * canvasHeight) / TEN_THOUSAND);
  }

  function transXFromCanvas(x: number) {
    return Math.floor((x / canvasWidth) * TEN_THOUSAND);
  }

  function transYFromCanvas(y: number) {
    return Math.floor((y / canvasHeight) * TEN_THOUSAND);
  }

  function showRule(ctx: CanvasRenderingContext2D) {
    console.log(
      "calling show rule x:",
      points[0].x,
      "y:",
      points[0].y,
      "candraw:",
      canDraw,
    );
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);
    console.log("line", canvasWidth, canvasHeight);

    ctx.beginPath();
    ctx.globalAlpha = 1;
    for (let i = 0; i < points.length; i++) {
      ctx.moveTo(transX2Canvas(points[i].x), transY2Canvas(points[i].y));
      // if (i == 0 || !canDraw || i !== points.length - 1) {
      ctx.arc(
        transX2Canvas(points[i].x),
        transY2Canvas(points[i].y),
        5,
        0,
        Math.PI * 2,
      );
      // }
      ctx.fillStyle = "white";
      ctx.stroke();
      ctx.fill();
    }
    ctx.closePath();

    ctx.beginPath();
    ctx.lineWidth = 2;
    let tmpX = transX2Canvas(points[0].x);
    let tmpY = transY2Canvas(points[0].y);
    ctx.moveTo(tmpX, tmpY);
    ctx.strokeStyle = REGION_INDEX_COLOR[ruleIndex];
    ctx.fillStyle = REGION_INDEX_COLOR[ruleIndex];
    for (let i = 1; i < points.length; i++) {
      tmpX = transX2Canvas(points[i].x);
      tmpY = transY2Canvas(points[i].y);

      ctx.lineTo(transX2Canvas(points[i].x), transY2Canvas(points[i].y));
    }
    if (canDraw && cursePoint) {
      ctx.lineTo(transX2Canvas(cursePoint.x), transY2Canvas(cursePoint.y));
    }

    ctx.stroke();
    if (!canDraw) {
      ctx.closePath();
      ctx.stroke();
      ctx.globalAlpha = 0.3;
      ctx.fill();
    }
  }

  useEffect(() => {
    if (regionDetection?.polygon?.points?.length > 0) {
      setPoints(regionDetection?.polygon?.points);
      setCanDraw(false);
    } else {
      setPoints([]);
      setCanDraw(true);
    }
  }, [regionDetection]);

  useEffect(() => {
    if (canvasWidth > 0 && refRuleCanvas.current) {
      refRuleCanvas.current.width = canvasWidth;
      refRuleCanvas.current.height = canvasHeight;
      const ctx = refRuleCanvas.current.getContext("2d");
      console.log("--- points", points, "regionDetection", regionDetection);
      if (points?.length > 0) {
        showRule(ctx);
      } else {
        ctx.clearRect(0, 0, canvasWidth, canvasHeight);
      }
    }
  }, [canvasWidth, points, cursePoint, canDraw]);

  const posOutSide = (t: number) => {
    return t < 0 || t > TEN_THOUSAND;
  };

  const handlePointMoving = (x: number, y: number) => {
    const ctx = refRuleCanvas.current.getContext("2d");
    if (regionMoving) {
      const dx = x - startRegionMovePos.x;
      const dy = y - startRegionMovePos.y;
      let xOut = false;
      let yOut = false;
      for (let i = 0; i < points.length; i++) {
        if (posOutSide(points[i].x + transXFromCanvas(dx))) {
          xOut = true;
        }
        if (posOutSide(points[i].y + transYFromCanvas(dy))) {
          yOut = true;
        }
      }
      for (let i = 0; i < points.length; i++) {
        if (!xOut) {
          points[i].x = points[i].x + transXFromCanvas(dx);
        }
        if (!yOut) {
          points[i].y = points[i].y + transYFromCanvas(dy);
        }
      }

      setPoints([...points]);
      setStartRegionMovePos({ x, y });
    } else if (pointMoving) {
      if (!posOutSide(transXFromCanvas(x))) {
        points[pointMovingIndex].x = transXFromCanvas(x);
      }
      if (!posOutSide(transYFromCanvas(y))) {
        points[pointMovingIndex].y = transYFromCanvas(y);
      }
      setPoints([...points]);
    } else {
      // just change mouse style
      if (mouseInPoints(x, y) >= 0) {
        refRuleCanvas.current.style.cursor = "Crosshair";
      } else if (ctx.isPointInPath(x, y)) {
        refRuleCanvas.current.style.cursor = "move";
      } else {
        refRuleCanvas.current.style.cursor = "default";
      }
    }
  };

  const mouseInPoint = (
    x: number,
    y: number,
    pointX: number,
    pointY: number,
  ) => {
    if (
      Math.abs(transX2Canvas(pointX) - x) < 5 &&
      Math.abs(transY2Canvas(pointY) - y) < 5
    ) {
      return true;
    }

    return false;
  };

  const mouseInPoints = (x: number, y: number) => {
    for (let i = 0; i < points.length; i++) {
      if (mouseInPoint(x, y, points[i].x, points[i].y)) {
        return i;
      }
    }
    return -1;
  };

  const onMouseMove = (e: any) => {
    console.log("onMouseMove");
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    if (canDraw) {
      if (isDrawing) {
        const correctX = Math.max(
          0,
          Math.min(TEN_THOUSAND, transXFromCanvas(x)),
        );
        const correctY = Math.max(
          0,
          Math.min(TEN_THOUSAND, transYFromCanvas(y)),
        );

        setCursePoint({ x: correctX, y: correctY });
      } else {
        // refRuleCanvas.current.style.cursor = 'Crosshair';
      }
    } else {
      handlePointMoving(x, y);
    }
  };

  const onMouseDown = (e: any) => {
    if (canDraw) {
      return;
    }
    console.log("onMouseDown");
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const ctx = refRuleCanvas.current.getContext("2d");
    const index = mouseInPoints(x, y);
    if (index >= 0) {
      setPointMoving(true);
      setPointMovingIndex(index);
    } else if (ctx.isPointInPath(x, y)) {
      setRegionMoving(true);
      setStartRegionMovePos({ x, y });
    }
  };

  const onMouseUp = (e: any) => {
    if (canDraw) {
      const rect = e.target.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      if (points?.length > 0 && mouseInPoint(x, y, points[0].x, points[0].y)) {
        // end drawing while mouse up on the first point
        console.log("end drawing");
        setCanDraw(false);
        setIsDrawing(false);
        updateRegionDetection(points);
      } else {
        console.log("mouse up");
        setIsDrawing(true);
        // points.pop();
        const exist = points.find(
          (point) =>
            point.x === transXFromCanvas(x) && point.y === transYFromCanvas(y),
        );
        if (!exist && points.length < 6)
          setPoints([
            ...points,
            { x: transXFromCanvas(x), y: transYFromCanvas(y) },
          ]);
      }
    } else {
      if (regionMoving || pointMoving) {
        updateRegionDetection(points);
        setRegionMoving(false);
        setPointMoving(false);
      }
    }
  };

  const onDoubleClick = (e: any) => {
    if (!isDrawing) {
      return;
    }
    console.log("mouse onDoubleClick");
    setCanDraw(false);
    setIsDrawing(false);
    updateRegionDetection(points);
  };

  return (
    <div
      className="absolute z-10 "
      style={{
        width: canvasWidth,
        height: canvasHeight,
        top: canvasOffsetTop,
        left: canvasOffsetLeft,
      }}
      onMouseMove={onMouseMove}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onDoubleClick={onDoubleClick}
    >
      <canvas ref={refRuleCanvas} />
    </div>
  );
}

export default RegionRuleDraw;
